import React, { useState, useEffect } from 'react';
import Classes from './styles/style.module.css';
import { useDispatch, useSelector } from 'react-redux';
import Footer from '../../GlobalComp/Footer/Footer';
import { useSnackbar } from 'notistack';
import backend from '../../../api';
import { CircularProgress, Box } from '@mui/material';

function ContactUs() {
    const { user } = useSelector((state) => state.auth);
    const { enqueueSnackbar } = useSnackbar();
    const [sendMsg, setSendMsg] = useState(false);
    const [loading, setLoading] = useState(false); // Added loading state
    const [width, setWidth] = useState(window.innerWidth);
    const companyInfo = useSelector((state) => state.companyInfo?.info);

    const updateDimensions = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    const [emptyCompanyTypeError, setEmptyCompanyTypeError] = useState(false);

    const [formdata, setFormdata] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: '',
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormdata({
            ...formdata,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { firstName, lastName, email, message } = formdata || {};

        if (!firstName?.trim() || !lastName?.trim() || !email?.trim() || !message?.trim()) {
            enqueueSnackbar('Please enter all fields', { variant: 'error' });
            return;
        }

        const body = {
            fullname: `${firstName.trim()} ${lastName.trim()}`,
            email: email.trim(),
            message: message.trim(),
        };

        setLoading(true); // Start loading
        try {
            const res = await backend.post('/email/contactus', body);
            if (res?.status === 200) {
                enqueueSnackbar('🎉 Message Sent', { variant: 'success' });
                setSendMsg(true);
                setFormdata({ firstName: '', lastName: '', email: '', message: '' }); // Clear form
            }
        } catch (err) {
            console.error(err);
            enqueueSnackbar('Something went wrong while sending the email', { variant: 'error' });
        } finally {
            setLoading(false); // Stop loading
        }
    };

    return (
        <div className={Classes.backgroundImage}>
            <div className={Classes.navContainer} style={{ boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)' }}>
                <div>
                    <a href="/" style={{ width: 'fit-content' }}>
                        <div className="logo">
                            <img src={'/logo.png'} alt="Tawaf logo" style={{ height: '2.2rem' }} />
                            <h3 style={{ textDecoration: 'none' }}>Tawaf</h3>
                        </div>
                    </a>
                </div>
                <nav className={Classes.navMenu}></nav>
                <div>
                    <a href="/" className={Classes.flexAlign}>
                        <h5 className={Classes.goBackTxt}>
                            Go back to <span>{user ? 'dashboard' : 'home'}</span>
                        </h5>
                    </a>
                </div>
            </div>
            <div className={Classes.hero}>
                <h1>Contact us</h1>
                <Box sx={{ position: 'relative' }}>
                    <form onSubmit={handleSubmit} className={Classes.form_con}>
                        {loading && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                    zIndex: 10,
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        )}
                        <div className={Classes.form_con_row}>
                            <input
                                className={Classes.input_field}
                                placeholder="First name"
                                name="firstName"
                                type="text"
                                required
                                value={formdata.firstName}
                                onChange={handleChange}
                            />
                            <input
                                className={Classes.input_field}
                                placeholder="Last name"
                                name="lastName"
                                type="text"
                                required
                                value={formdata.lastName}
                                onChange={handleChange}
                            />
                        </div>
                        <input
                            className={Classes.input_field}
                            placeholder="Email"
                            name="email"
                            type="email"
                            required
                            value={formdata.email}
                            onChange={handleChange}
                        />
                        <textarea
                            rows={5}
                            className={Classes.input_field}
                            placeholder="Message"
                            name="message"
                            type="text"
                            value={formdata.message}
                            onChange={handleChange}
                            required
                        />
                        <div className={Classes.btnCon}>
                            <button type="submit" disabled={loading}>
                                <h5 className={Classes.m0}>Send message</h5>
                            </button>
                            {/* {sendMsg && (
                                <div className={Classes.msgCon}>
                                    <img className={Classes.checkmark} src="./icons/check-mark.png" alt="Checkmark" />
                                    <h5>Your inquiry was successfully received. We will get back to you within 48 hours.</h5>
                                </div>
                            )} */}
                        </div>
                    </form>
                </Box>
            </div>
            <Footer />
        </div>
    );
}

export default ContactUs;